// THIS FILE IS AUTOGENERATED WHEN PAGES ARE UPDATED
import { lazy, Suspense } from "react";
import { RouteObject } from "react-router";
import ProtectedRoute from "./components/ProtectedRoute";
import { MainLayout } from "./components/MainLayout";
import VectorLoaderPage from "pages/VectorLoaderPage.tsx";

const App = lazy(() => import("./pages/App.tsx"));
const LoginPage = lazy(() => import("./pages/LoginPage.tsx"));
const PayloadPage = lazy(() => import("./pages/payload"));
const ProjectsPage = lazy(() => import("./pages/projects"));
const AiServicesPage = lazy(() => import("./pages/ai-services"));
const InstructionsPage = lazy(() => import("./pages/instructions"));
const ToolsPage = lazy(() => import("./pages/tools"));
const FoaldsPage = lazy(() => import("./pages/foalds"));
const FlowsPage = lazy(() => import("./pages/flows"));

// Create our own SuspenseWrapper to avoid circular dependency
const SuspenseWrapper = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<div>Loading...</div>}>{children}</Suspense>
);

export const userRoutes: RouteObject[] = [
  // Public routes
  { path: "/", element: <SuspenseWrapper><App /></SuspenseWrapper> },
  { path: "/login", element: <SuspenseWrapper><LoginPage /></SuspenseWrapper> },

  // Protected routes
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <MainLayout />,
        children: [
          { path: "/projects", element: <SuspenseWrapper><ProjectsPage /></SuspenseWrapper> },
          { path: "/payloads", element: <SuspenseWrapper><PayloadPage /></SuspenseWrapper> },
          { path: "/ai-services", element: <SuspenseWrapper><AiServicesPage /></SuspenseWrapper> },
          { path: "/instructions", element: <SuspenseWrapper><InstructionsPage /></SuspenseWrapper> },
          { path: "/tools", element: <SuspenseWrapper><ToolsPage /></SuspenseWrapper> },
          { path: "/vector-loader", element: <SuspenseWrapper><VectorLoaderPage /></SuspenseWrapper> },
          { path: "/folds", element: <SuspenseWrapper><FoaldsPage /></SuspenseWrapper> },
          { path: "/flows", element: <SuspenseWrapper><FlowsPage /></SuspenseWrapper> },
        ],
      },
    ],
  },
];